var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "product-cate cursor-pointer"
  }, [_c('div', {
    staticClass: "font-weight-bold ml-2 mr-2 mt-1 mb-1 d-flex justify-content-between align-content-center",
    staticStyle: {
      "color": "rgba(38,38,38,.7)",
      "font-size": "16px"
    },
    on: {
      "click": function ($event) {
        _vm.visible = !_vm.visible;
      }
    }
  }, [_c('span', {
    staticClass: "font-weight-bold",
    staticStyle: {
      "margin-top": "3px",
      "font-size": "14px"
    }
  }, [_vm._v(" " + _vm._s(_vm.item.name) + " ")]), _c('ez-icon', {
    attrs: {
      "size": "24",
      "icon": "ezAr-icon-chevron-down"
    }
  })], 1), _c('b-collapse', {
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('div', {
    staticClass: "row mb-2"
  }, _vm._l(_vm.item.appLinks, function (_ref) {
    var url = _ref.url,
      icon = _ref.icon,
      name = _ref.name,
      description = _ref.description,
      hide = _ref.hide;
    return _c('div', {
      staticClass: "col-3 mt-1 hover-f5",
      class: {
        'd-none': hide
      }
    }, [_c('a', {
      staticClass: "d-flex flex-column align-items-center justify-content-center item ",
      attrs: {
        "target": "_blank",
        "href": url
      }
    }, [_c('img', {
      attrs: {
        "src": icon,
        "width": "45",
        "height": "45"
      }
    }), _vm._v(" " + _vm._s(name) + " "), _c('span', {
      staticClass: "text-secondary"
    }, [_vm._v(_vm._s(description))])])]);
  }), 0)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }